export default function setMapViewValue({ state }, mapViewKey, mapViewValue) {
  state.set(['listingsMapView', mapViewKey], mapViewValue);
}
